import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';

// Style
import './Popup.scss';

const Popup = ({ children, open, onClose, dialogClassName }) => {
  return (
    <Dialog className={dialogClassName || "popup-container"} open={open} onClose={onClose} maxWidth={false}>
      <DialogContent >{children}</DialogContent>
    </Dialog>
  );
};

export default Popup;

